<template>
  <div
    :class="[
      $style.vgp_input_box,
    ]"
  >
    <div
      ref="input_field"
      :class="[$style.vgp_input]"
    >
      <span
        :class="[$style.wrap]"
        v-html="selectedValue"
      />
    </div>
    <div
      ref="drop"
      :style="{
        top: coordinates.top,
        left: coordinates.left,
        // 'max-height': '240px',
        'max-height': '220px',
      }"

      :class="[$style.dropdown, dropToBottom ? '' : $style.dropdown_top, $style.drop]"
    >
      <div
        v-if="options.length > 5 || (itemTemplate === 'user' && options.length > 3)"
        :class="[$style.search_wrap, $style.search_wrap_grid]"
      >
        <sprite
          :name="'search'"
          :type="'regular'"
          :size="24"
          :class="[ $style.search_icon]"
        />
        <input
          :id="'select-drop-trigger-' + componentKey"
          ref="search_input"
          v-model="searchTxt"
          :class="[$style.search_input]"
          class="mousetrap"
          data-testid="gp_autotest_gantt_grid_select_search_input"
          :placeholder="searchTxt ? '' : searchPlaceholderText"
          type="text"
        >
      </div>
      <div
        ref="drop"
        :class="[ 'gantt_scroll']"
        @scroll.stop
      >
        <template v-if="showItems.length">
          <div
            v-for="groupName in groupSet"
            :key="componentKey + groupName"
          >
            <div
              v-if="groupName"
              :class="$style.group_devider"
              :style="{ color: '#424242' }"
            >
              <span :class="$style.group_devider_name"> {{ groupName }} </span>
              <div :class="$style.group_devider_line" />
            </div>

            <div
              v-for="item in getItemsByGroupName(groupName)"
              :key="itemTemplate + item['id']"
              :data-testid="`gp_autotest_gantt_grid_select_item_${item['id']}`"
              :class="[$style.drop_item, 'js-drop-item']"
            >
              <input
                v-if="multiselect"
                :id="multiselect + item['id'] + '-' + componentKey"
                class="mousetrap"
                v-model="multiSelected"
                type="checkbox"
                :value="item"
              >
              <input
                v-else
                :id="multiselect + item['id'] + '-' + componentKey"
                v-model="singleSelected"
                class="mousetrap"
                type="radio"
                :value="item"
              >

              <label
                :class="$style.drop_item_text"
                :for="multiselect + item['id'] + '-' + componentKey"
              >
                <vgpChip
                  :text="item[trackByText]"
                  :preset="itemTemplate"
                  :txt-ellipsis="true"
                  :img-url="item[trackByImgUrl]"
                  :bg-color="item[trackByBgColor]"
                  :status-color="item[trackByStatusColor]"
                  :icon="item[trackByIconName]"
                  :fill-width="itemTemplate !== 'label'"
                  size="xs"
                />
              </label>
            </div>
          </div>
        </template>
        <template v-else>
          <div
            :class="$style.no_search"
            data-testid="gp_autotest_gantt_grid_select_no_matches"
            :style="{width: 96}"
          >
            <span> {{ noMatchesMessage }} </span>
          </div>
        </template>
      </div>

      <div
        v-if="showItems.length && (localSelected.length || (multiselect && showItems.length >= 2))"
        :class="$style.reset_button"
        data-testid="gp_autotest_gantt_grid_select_reset_button"
        @click="onSelectAllBtnClick"
      >
        <span v-if="multiselect">
          {{ isAllShowedItemsSelected ? locales('custom_column_reset_button_text') : locales('custom_column_select_all_text') }}
        </span>
        <span v-else>{{ locales('custom_column_reset_button_text') }} </span>
      </div>
    </div>
  </div>
</template>

<script>

import vgpChip from '$$vueCmp/chip/vgpChip.vue';
import sprite from '$$uiKitComp/VueIcon/svgSprite.vue';

export default {
  name: 'GridCustomListCellEditor',
  components: { sprite, vgpChip },
  props: {
    data: {
      type: [String, Object],
      default: null,
    },
    itemTemplate: {
      type: String,
      required: false,
      default: 'text',
      validator(value) {
        return ['text', 'user', 'label', 'withImg', 'withIcon', 'status'].includes(value);
      },
    },
    trackByIconName: { type: String, required: false, default: 'icon' },
    trackByImgUrl: { type: String, required: false, default: 'img' },
    trackByBgColor: { type: String, required: false, default: 'color' },
    trackByStatusColor: { type: String, required: false, default: 'color' },
    trackByText: { type: String, required: false, default: 'name' },
    groupBy: {
      type: String,
      required: false,
      default: '',
    },
    multiselect: {
      type: Boolean,
      required: false,
    },
    placeholder: {
      type: Object,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  emits: [
    'onChange',
  ],
  data() {
    return {
      locales: __,
      coordinates: {
        left: 'auto',
        top: 'auto',
      },
      dropToBottom: true,
      showItems: [],
      localSelected: [],
      searchTxt: '',
      searchPlaceholderText: __('filter_search_placeholder'),
      noMatchesMessage: __('no_matches_message_text'),
      selectedValue: '',
    };
  },
  computed: {
    isAllShowedItemsSelected() {
      if (this.localSelected.length < this.showItems.length) return false;

      const isAllSelected = this.showItems.every(item => this.localSelected.find(i => i.id == item.id));

      return isAllSelected;
    },
    multiSelected: {
      get() {
        return this.localSelected;
      },

      set(newSelected) {
        const preparedNewSelected = this.showItems.filter(option => newSelected.find(item => item.id == option.id));

        this.localSelected = preparedNewSelected;
        this.emitChange(preparedNewSelected.map(item => item.id));
      },
    },
    componentKey() {
      return `drop_select_${new Date().getTime()}`;
    },
    groupSet() {
      const set = [];

      this.showItems.forEach(item => {
        const groupName = (this.groupBy in item) ? item[this.groupBy] : null;

        if (!set.includes(groupName)) {
          groupName ? set.push(groupName) : set.unshift(groupName);
        }
      });

      return set;
    },
    singleSelected: {
      get() {
        return this.localSelected[0] || '';
      },

      set(newVal) {
        this.localSelected = [newVal];
        this.emitChange([this.localSelected[0].id]);
      },
    },
    selectedArray() {
      if (Array.isArray(this.data)) {
        return [...this.data];
      }

      if (this.data) {
        return [this.data];
      }

      return [];
    },

  },
  watch: {
    selectedArray: {
      handler(val) {
        this.localSelected = val;
      },
      immediate: true,
    },
    searchTxt(val) {
      this.updateShowedItemsBySearch();
    },
    localSelected: {
      handler() {
        switch (this.itemTemplate) {
        case 'label':
          this.getTag();
          break;
        case 'user':
          this.getInput();
          break;
        case 'text':
          this.getMultiselect();
          break;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.getCoordinates();
      if (this.multiselect) {
        this.sortBySelected();
      }
    });
  },
  beforeMount() {
    this.showItems = [...this.options];
  },
  methods: {
    sortBySelected() {
      this.showItems = [...this.showItems.sort((a, b) => {
        const isSelectedA = this.localSelected.find(o => o.id === a.id);
        const isSelectedB = this.localSelected.find(o => o.id === b.id);

        if (isSelectedA && isSelectedB) {
          return a.sort_order - b.sort_order;
        }

        if (isSelectedA && !isSelectedB) return -1;
        if (!isSelectedA && isSelectedB) return 1;
      })];
    },
    emitChange(val) {
      this.$emit('onChange', [...val]);
    },
    getCoordinates() {
      const coordinates = this.placeholder.getBoundingClientRect();
      const clientHeight = document.documentElement.clientHeight;
      const elementHeight = this.$refs.drop.offsetHeight;

      this.dropToBottom = (coordinates.bottom + elementHeight) < clientHeight;

      if (this.dropToBottom) {
        this.coordinates = {
          top: `${coordinates.bottom + 1}px`,
          left: `${coordinates.left}px`,
        };
      } else {
        this.coordinates = {
          top: `${coordinates.top - elementHeight - 1}px`,
          left: `${coordinates.left}px`,
        };
      }
    },
    getItemsByGroupName(name) {
      if (name === null) {
        return this.showItems.filter(item => !(this.groupBy in item));
      }

      return this.showItems.filter(item => item[this.groupBy] === name);
    },
    onSelectAllBtnClick() {
      if (!this.multiselect) {
        this.localSelected = [];
        this.emitChange(this.localSelected);
      }

      if (this.multiselect && this.isAllShowedItemsSelected) {
        this.localSelected = [];
        this.emitChange(this.localSelected);
      } else if (this.multiselect) {
        this.localSelected = [...this.showItems];
        this.emitChange(this.localSelected.map(item => item.id));
      }
    },
    updateShowedItemsBySearch() {
      if (!this.searchTxt) {
        this.showItems = [...this.options];

        return;
      }

      const str = this.searchTxt.toLowerCase();

      this.showItems = this.options.filter(item => {
        const value = item[this.trackByText].toLowerCase();

        if (value.includes(str)) {
          return true;
        }
      });
    },

    getMultiselect() {
      this.selectedValue = this.localSelected.map(selectedItem => selectedItem[this.trackByText]).join(', ');
    },

    getTag() {
      const selectedElems = this.localSelected;
      let resultTag = '';
      const maxElemsToShow = 2;

      if (selectedElems.length && selectedElems.length <= maxElemsToShow) {
        resultTag = selectedElems.map(elem => {
          const tag = `<span class="${this.$style.tag_text}">${elem.value}</span>`;

          return `<span class="${this.$style.tag_item}" style="background: ${elem.color}">${tag}</span>`;
        }).join('');
      }

      if (selectedElems.length && selectedElems.length > maxElemsToShow) {
        const tags = selectedElems.slice(0, maxElemsToShow).map(elem => {
          const tag = `<span class="${this.$style.tag_text}">${elem.value[0]}</span>`;

          return `<span class="${this.$style.tag_item}" style="width: 18px; background: ${elem.color}">${tag}</span>`;
        }).join('');

        resultTag = `${tags}${selectedElems.length > maxElemsToShow ? `<span class="${this.$style.rest_count}">+${selectedElems.length - maxElemsToShow}</span>` : ''}`;
      }

      this.selectedValue = resultTag;
    },
    getInput() {
      const selectedElems = this.localSelected;

      let resultTag = '';
      const maxElemsToShow = 2;

      if (selectedElems.length && selectedElems.length < maxElemsToShow) {
        const picture = `<span class="${this.$style['resources-icon']}" style="background-image: url(${selectedElems[0].img})"></span>`;
        const text = `<span class="resources-text">${selectedElems[0].name}</span>`;

        resultTag = `<span class="${this.$style['resources-item']}">${picture}${text}</span>`;
      }

      if (selectedElems.length && selectedElems.length >= maxElemsToShow) {
        const maxElemsToShow = 2;
        const iconTags = selectedElems.slice(0, maxElemsToShow).map(elem => {
          const picture = elem.img ? `<span class="${this.$style['resources-icon']}" style="background-image: url(${elem.img})"></span>` : '';

          return `<span class="${this.$style['resources-item']}">${picture}</span>`;
        }).join('');

        resultTag = `${iconTags}${selectedElems.length > maxElemsToShow ? `<span class="${this.$style.rest_count}">+${selectedElems.length - maxElemsToShow}</span>` : ''}`;
      }

      this.selectedValue = resultTag;
    },
  },
};
</script>

<style lang="less" src="./select.less" module></style>
